import { render, staticRenderFns } from "./OutType.vue?vue&type=template&id=bd13af18&scoped=true"
import script from "./OutType.vue?vue&type=script&lang=js"
export * from "./OutType.vue?vue&type=script&lang=js"
import style0 from "./OutType.vue?vue&type=style&index=0&id=bd13af18&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd13af18",
  null
  
)

export default component.exports